"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstCreatedFieldLogic = void 0;
var first_created_fieldtype_1 = require("./first-created.fieldtype");
Object.defineProperty(exports, "FirstCreatedFieldLogic", { enumerable: true, get: function () { return first_created_fieldtype_1.FirstCreatedFieldLogic; } });
